import React from "react";
import * as flags from "country-flag-icons/react/3x2";
import { Globe } from "lucide-react";
import { formatPhone, countryName } from "@/lib/phone";
import { cn } from "@/lib/utils";

export const PhoneFlag = ({ country, ...props }) => {
  const Flag = flags[country];
  return Flag ? <Flag aria-hidden="true" className="w-5 h-auto shrink-0 rounded-[2px]" {...props} /> : <Globe aria-hidden="true" className="w-5 h-4 shrink-0" {...props} />;
};

export const PhoneDisplay = ({ value, country = "IT", fallback = "—", className, ...props }) => {
  const id = React.useId(), phone = formatPhone(value, country);
  return <span data-testid={`phone-display-${id}`} className={cn("inline-flex max-w-full items-center gap-1.5 align-middle", className)} {...props}>
    {phone.recognized && phone.full && <PhoneFlag country={phone.country} />}
    <span className="min-w-0 tabular-nums [overflow-wrap:anywhere]" title={phone.recognized && phone.full ? countryName(phone.country) : undefined}>{phone.full ? phone.text : fallback}</span>
  </span>;
};
